import { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import useMediaQuery from '@mui/material/useMediaQuery';
import Link from '@mui/material/Link';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

import ServiceForListComponent from "../../components/ServiceForListComponent.js";

const config = require("../../constants/constants.js")

const ServiceListPageComponent = ({ getServices, categories }) => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [attrsFilter, setAttrsFilter] = useState([]); // collect category attributes from db and show on the webpage
  const [attrsFromFilter, setAttrsFromFilter] = useState([]); // collect user filters for category attributes
  const [showResetFiltersButton, setShowResetFiltersButton] = useState(false);

  const [filters, setFilters] = useState({}); // collect all filters
  const [price, setPrice] = useState(500);
  const [ratingsFromFilter, setRatingsFromFilter] = useState({});
  const [categoriesFromFilter, setCategoriesFromFilter] = useState({});
  const [sortOption, setSortOption] = useState("");
  const [paginationLinksNumber, setPaginationLinksNumber] = useState(null);
  const [pageNum, setPageNum] = useState(null);
  const [nomeTipoServizio, setNomeTipoServizio] = useState("");

  const { categoryName } = useParams() || "";
  const { pageNumParam } = useParams() || 1;
  const { searchQuery } = useParams() || "";
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (categoryName) {
      let categoryAllData = categories.find(
        (item) => item.name === categoryName.replaceAll(",", "/")
      );
      if (categoryAllData) {
        let mainCategory = categoryAllData.name.split("/")[0];
        let index = categories.findIndex((item) => item.name === mainCategory);
        setAttrsFilter(categories[index].attrs);
      }
    } else {
      setAttrsFilter([]);
    }
  }, [categoryName, categories]);

  useEffect(() => {
    if (Object.entries(categoriesFromFilter).length > 0) {
      setAttrsFilter([]);
      var cat = [];
      var count;
      Object.entries(categoriesFromFilter).forEach(([category, checked]) => {
        if (checked) {
          var name = category.split("/")[0];
          cat.push(name);
          count = cat.filter((x) => x === name).length;
          if (count === 1) {
            var index = categories.findIndex((item) => item.name === name);
            setAttrsFilter((attrs) => [...attrs, ...categories[index].attrs]);
          }
        }
      });
    }
  }, [categoriesFromFilter, categories]);

  useEffect(() => {
    getServices(categoryName, pageNumParam, searchQuery, filters, sortOption)
      .then((services) => {
        setServices(services.services);
        setPaginationLinksNumber(services.paginationLinksNumber);
        setPageNum(services.pageNum);
        setLoading(false);
        setNomeTipoServizio(categoryName);
      })
      .catch((er) => {
        console.log(er);
        setError(true);
      });
  }, [categoryName, pageNumParam, searchQuery, filters, sortOption]);

  const handleFilters = () => {
    navigate(location.pathname.replace(/\/[0-9]+$/, ""));
    setShowResetFiltersButton(true);
    setFilters({
      price: price,
      rating: ratingsFromFilter,
      category: categoriesFromFilter,
      attrs: attrsFromFilter,
    });
  };

  const resetFilters = () => {
    setShowResetFiltersButton(false);
    setFilters({});
    window.location.href = "/service-list";
  };

  const [applicativo, setApplicativo] = useState("");
  const [ragioneSociale, setRagioneSociale] = useState("");
  const [email, setEmail] = useState("");
  const [telefonoCallFromSite, setTelefonoCallFromSite] = useState("");
  const [linkWhatsapp, setLinkWhatsapp] = useState("");
  const [linkFacebook, setLinkFacebook] = useState("");
  const [linkInstagram, setLinkInstagram] = useState("");
  const [linkTwitter, setLinkTwitter] = useState("");
  const [linkLinkedin, setLinkLinkedin] = useState("");
  const [urlSiteImageServer, setUrlSiteImageServer] = useState("");
  const [urlCustomerImageServer, setUrlCustomerImageServer] = useState("");
  const [isShopActive, setIsShopActive] = useState("");
  const [isIconLoginActive, setIsIconLoginActive] = useState("");

  const [showPriceProducts, setShowPriceProducts] = useState("");
  const [showPriceServices, setShowPriceServices] = useState("");
  const [showPriceEvents, setShowPriceEvents] = useState("");
  const [showReviews, setShowReviews] = useState("");

  const getConfigByProgressivoApiRequest = async (progressivoRagSoc) => {
    console.log("[getConfigByProgressivoApiRequest] leggo const con progressivo =", progressivoRagSoc);
    const url = `/api/configs/progressivo/` + progressivoRagSoc;
    const { data } = await axios.get(url);
    return data
  }

  useEffect(() => {
    getConfigByProgressivoApiRequest('0001').then((data) => {
      //console.log(`data =`, data);
      setApplicativo(data?.applicativo);
      setRagioneSociale(data?.ragioneSociale);
      setEmail(data?.email);
      setTelefonoCallFromSite("tel:" + data?.telefonoCallFromSite)
      setLinkWhatsapp("https://wa.me/" + data?.linkWhatsapp);
      setLinkFacebook(data?.linkFacebook);
      setLinkInstagram(data?.linkInstagram);
      setLinkTwitter(data?.linkTwitter);
      setLinkLinkedin(data?.linkLinkedin);
      setUrlSiteImageServer(data?.urlSiteImageServer);
      setUrlCustomerImageServer(data?.urlCustomerImageServer);
      //setIsShopActive(data?.isShopActive === "Si" ? true : false);
      //setIsIconLoginActive(data?.isIconLoginActive === "Si" ? true : false);
      setIsShopActive(data?.isShopActive);
      setIsIconLoginActive(data?.isIconLoginActive);
      setShowPriceProducts(data?.showPriceProducts)
      setShowPriceServices(data?.showPriceServices)
      setShowPriceEvents(data?.showPriceEvents)
      setShowReviews(data?.showReviews);
      //console.log(`data?.applicativo =`, data?.applicativo);
      //console.log(`data?.linkWhatsapp =`, data?.linkWhatsapp);
      //console.log(`data?.linkFacebook =`, data?.linkFacebook);
      //console.log(`data?.linkInstagram =`, data?.linkInstagram);
      //console.log(`data?.linkTwitter =`, data?.linkTwitter);
      //console.log(`ragioneSociale =`, data?.ragioneSociale);
      //console.log(`urlCustomerImageServer =`, data?.urlCustomerImageServer);
      //console.log(`isShopActive =`, data?.isShopActive);
      //console.log(`isIconLoginActive =`, data?.isIconLoginActive);
    })
      .catch((er) => {
        console.log(er);
      });
  }, [ragioneSociale, setEmail, setUrlCustomerImageServer])

  return (


    <Box sx={{ flexGrow: 1 }}>

      <Grid
        container
        size={{ xs: 12, md: 12 }}
        paddingTop={{ xs: 0, md: 0 }}
        paddingLeft={{ xs: 0, md: 0 }}
        paddingRight={{ xs: 0, md: 0 }}
        spacing={{ xs: 0, md: 0 }}
        sx={{
          // background: '#242424',   // sfondo mainMenu = nero 
          background: '#2074d4'       // sfondo mainMenu = blu navy
        }}
      >
        <Breadcrumbs
          separator="›"
          aria-label="breadcrumb"
          size={{ xs: 12, md: 4 }}
          paddingTop={{ xs: 0, md: 0 }}
          paddingLeft={{ xs: 8, md: 17 }}   // per posizione dopo logo di sx
          paddingRight={{ xs: 1, md: 0 }}
          spacing={{ xs: 0, md: 0 }}
          color="white"
          //fontFamily="Roboto"
          fontFamily="sans-serif"
          textTransform='none'
          fontSize={14}
          //fontStyle= 'italic'
          //fontWeight= {100}
        >
          <Link underline="hover" color="inherit" href="/">
            <HomeOutlinedIcon />
          </Link>
          <Link
            underline="hover"
            color="inherit"
            href="/servizi"
          >
            {config.BC_SERVIZI}
          </Link>
          <Typography
            sx={{
              color: 'white',
              fontFamily:"sans-serif",
              textTransform:'none',
              fontSize:14,
            }}
          >
            {nomeTipoServizio}
          </Typography>

        </Breadcrumbs>
      </Grid>

    {/* 
      <Breadcrumbs separator="›" aria-label="breadcrumb"
        size={{ xs: 12, md: 4 }}
        paddingTop={{ xs: 1, md: 1 }}
        paddingLeft={{ xs: 2, md: 8 }}
        paddingRight={{ xs: 1, md: 8 }}
        spacing={{ xs: 2, md: 2 }}
      >
        <Link underline="hover" color="inherit" href="/">
          <Typography
            sx={{
              color: 'text.primary',
              fontFamily: 'Roboto',
              textTransform: 'none',
              fontSize: 14,
            }}
          >
            {config.BC_HOME}
          </Typography>
        </Link>
        <Link
          underline="hover"
          color="inherit"
          href="/servizi"
        >
          <Typography
            sx={{
              color: 'text.primary',
              fontFamily: 'Roboto',
              textTransform: 'none',
              fontSize: 14,
            }}
          >
            {config.BC_SERVIZI}
          </Typography>
        </Link>
        <Typography
          sx={{
            color: 'text.primary',
            fontFamily: 'Roboto',
            textTransform: 'none',
            fontSize: 14,
          }}
        >
          {categoryName}
        </Typography>
      </Breadcrumbs>
    */}

      <Grid
        container
        size={{ xs: 12, md: 4 }}
        paddingTop={{ xs: 3, md: 3 }}
        paddingLeft={{ xs: 2, md: 8 }}
        paddingRight={{ xs: 1, md: 8 }}
        spacing={{ xs: 2, md: 2 }}
      >

        {loading ? (
          <h1>Caricamento prodotti ....</h1>
        ) : error ? (
          <h1>Errore nel caricamento prodotti ...</h1>
        ) : (
          services.map((service) => (
            <ServiceForListComponent
              key={service._id}
              images={service.images}
              name={service.name}
              description={service.description}
              note={service.note}
              price={service.price}
              rating={service.rating}
              reviewsNumber={service.reviewsNumber}
              serviceId={service._id}
              showPrice={showPriceServices}
              showReviews={showReviews}
            />
          ))
        )}

        {/* 
          {paginationLinksNumber > 1 ? (
            <PaginationComponent
              categoryName={categoryName}
              searchQuery={searchQuery}
              paginationLinksNumber={paginationLinksNumber}
              pageNum={pageNum}
            />
          ) : null}
          */}

      </Grid>

      <Box
        sx={{
          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
          height: 40
        }}
      />

    </Box>

  );
};

export default ServiceListPageComponent;
